import { useState, useEffect } from 'react';
import { message as antdMessage, Button, Checkbox, Form, Select, Input, Modal } from 'antd';
import PartnerForm from '../PartnerForm';

import styles from './index.module.scss';
import { getIsMobileWidth } from '@elem/utils/devices';

export default function Comp({ visible, onClose }: any) {
    const [modalVisible, setModalVisible] = useState(visible);
    const isMobile = getIsMobileWidth() || false; //是否是移动端

    const handleCancel = () => {
        onClose && onClose();
    };

    useEffect(() => {
        if (visible && isMobile) {
            document.body.classList.add(styles.modalOpen);
        } else {
            document.body.classList.remove(styles.modalOpen);
        }
        setModalVisible(visible);
        return () => {
            document.body.classList.remove(styles.modalOpen);
        };
    }, [visible]);

    return (
        <Modal maskClosable={false} visible={modalVisible} onCancel={handleCancel} className={styles.partnerModal} footer={null}>
            <PartnerForm onSuccess={handleCancel} />
        </Modal>
    );
}
